<template>
  <div class="text-center my-5">
    <h3>Please wait while we change the Active Location Settings.</h3>
    <i class="fas fa-sync-alt fa-spin fa-5x my-5"/>
  </div>
</template>

<script>
import userInfoMixin from '@/common/mixins/user-info-mixin'
import { mapActions } from 'vuex'
import { SettingsFactory } from '@/common/utils/SettingsFactory'

export default {
  name: 'ChangeLocation',
  mixins: [userInfoMixin],
  data () {
    return {
      from: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.changeLocation(to.query.redir ? to.query.redir : from)
    })
  },
  methods: {
    ...mapActions('login', ['setActiveLocation']),
    async changeLocation (fromPage) {
      let locationId = this.$route.query.locationId
      SettingsFactory.instance.reset()
      await this.setActiveLocation(locationId)
      this.$router.push({
        name: fromPage.name,
        params: fromPage.params,
        query: { ...fromPage.query, locationId }
      })
        .then(() => {
          window.location.reload()
        })
        .catch(() => {})
    }
  }
}
</script>
